<template>
  <v-container fluid class="overlay pa-0" fill-height>
    <v-row dense>
        <v-col cols="12" sm="6">
            <v-list dense color="transparent">
                <v-list-item>
                    <v-list-item-icon>
                        <v-icon dark > mdi-phone </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title class="text-color-white font-weight-light">999-958-0477, 999-100-0034, 999-553-4482</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-col>
        <v-col cols="12" sm="6"  class="text-right">
            <v-btn @click="Sendlogin" class="pa-5" color="warning" dark tile>
                <v-icon class="mdi-36px" dark left> mdi-lock</v-icon>
                <span class="title font-weight-light">Área privada</span>
            </v-btn>
        </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="6">
        <v-img src="@/assets/images/grupo-personas.png" alt="Creditoria"/>
      </v-col>
      <v-col cols="12" sm="6">
        <div  class="overlay-panel">
          <img src="@/assets/images/logo_white.png" class="team-img pb-8" alt="Creditoria"/>
          <!-- px-8 my-4 md-title font-weight-bold | px-2 my-4 sm-title font-weight-bold -->
          <h1 class="px-2 my-4 text-sm-h3 text-md-h2 sm-description font-weight-bold">¡ Bienvenido !</h1>
          <div class="px-2 my-2 text-md-h4 font-weight-bold sm-description md-description"> Planes de adquirir una vivienda ? </div>
          <div class="px-2 my-2 text-md-h4 font-weight-bold sm-description md-description"> Simula tu Crédito Hipotecarios, en minutos </div>

          <v-btn color="info" class="my-10 font-weight-bold" elevation="0" @click="precalificar" dark rounded x-large>
          Simulador de Crédito
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router'
import { Validate } from '@/mixins/validateFormMixin'
export default {
  mixins: [Validate],
  data: () => ({
    valid: true,
    showeye: false,
    loger: null,
    session: {}
  }),
  components: {
  },
  methods: {
    ...mapActions(['PostServiceLogin']),
    Sendlogin () {
      router.push({ name: 'LoginView' })
    },
    login () {
      if (this.$refs.form.validate()) {
        this.valid = false
        this.PostServiceLogin({ url: '/login', data: this.session })
      }
    },
    precalificar () {
      // router.push({ name: 'PrecalificadorGralDatosView' })
      window.open('/PrecalificadorDatos', '_blank')
    }
  },
  computed: {
    ...mapGetters(['get_objectAccess'])
  },
  watch: {
    get_objectAccess (val) {
      this.valid = true
      if (val.message) {
        this.$swal({ type: 'error', icon: 'error', title: 'Error!', text: val.message })
        return
      }
      this.$cookies.set('token_cred', val.access_token)
      localStorage.setItem('permisos', JSON.stringify(val.user.roles[0]))
      const user = { id: val.user.id, email: val.user.correo, nombre: val.user.nombre, usuario: val.user.usuario }
      this.$cookies.set('user', user)
      router.push({ name: 'home' })
    }
  }
}
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css?family=Montserrat:400,800");
.text-color-white {
    color: white;
}
form {
  background-color: #ffffff;
  height: 100%;
}
form h1 {
  color: #d68110;
}
.container {
  background-color: #fff;
  /* border-radius: 10px; */
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  position: relative;
  overflow: hidden;
  max-width: 100%;
  min-height: 680px;
}

.form-container {
  position: absolute;
  top: 0;
  height: 100%;
  transition: all 0.6s ease-in-out;
}
.overlay-container {
  position: absolute;
  width: 100%;
  height: 100%;
}
.container.right-panel-active .overlay-container {
  transform: translateX(-100%);
}
.overlay {
  background: #026270;
  background: -webkit-linear-gradient(to right, #e260c6, #026270);
  background: linear-gradient(to right, #284563, #026270);
  background-repeat: no-repeat;
  background-size: cover;
  color: #ffffff;
  position: relative;
  height: 100%;
  width: 100%;
}
.container.right-panel-active .overlay {
  transform: translateX(50%);
}
.panel-imagen {
  height: 100%;
  width: 50%;
  position: absolute;
  top: 15%;
}
.overlay-panel {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  margin-top: 30px;
}
.container.right-panel-active .overlay-left {
  transform: translateX(0);
}
.container.right-panel-active .overlay-right {
  transform: translateX(20%);
}

.sign-in-container {
  left: 0;
  width: 50%;
  z-index: 2;
}
.team-img {
  width: 40%;
}

</style>
